import { Component } from '@angular/core';

@Component({
  selector: 'app-soup-configuration',
  templateUrl: './store-configuration.component.html',
  styleUrls: ['./store-configuration.component.css'],
})
export class StoreConfigurationComponent {}
